import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import styles from './LotteryEntry.module.css';

interface Props {
  main: (number | null)[];
  bonus: (number | null)[];
  disabled?: boolean;
  firstEntryDisabled?: boolean;
}
const LotteryEntry = observer((props: Props) => {
  return (
    <div
      className={clsx(
        styles.container,
        props.disabled && styles.disabled,
        props.firstEntryDisabled && styles.firstEntryDisabled,
      )}
    >
      {props.main.map((x, i) => (
        <span key={i} className={styles.ball}>
          <span className={styles.ballInner}>
            <span
              className={clsx(styles.ballInner2, 'daymadeTypographyMMedium')}
            >
              {x ?? '+'}
            </span>
          </span>
        </span>
      ))}
      {props.bonus.map((x, i) => (
        <span
          key={i}
          className={clsx(styles.ball, styles.bonusBall)}
          data-lottery-entry-bonus-ball
        >
          <span className={styles.ballInner}>
            <span className={clsx(styles.ballInner2, 'daymadeTypographyMBold')}>
              {x ?? '+'}
            </span>
          </span>
        </span>
      ))}
    </div>
  );
});

export default LotteryEntry;
